'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.16.2@axios/lib/cancel/isCancel.js
// module id = 53
// module chunks = 48